export const AUTH_TOKEN = 'envidom_auth_token';

export const cookiesSetting = { path: '/' };
